import React, { useEffect, useState }  from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import AccountsProfile from '../ui-componets/accounts-profile';
import BreadCrumbs from "../ui-componets/breadcrumbs";
import { getProfileData, postProfileData } from '../modules/details.ducks';
import {credentialChangeLogout} from "../modules/join.ducks";
import Loader from '../ui-componets/loader';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Back from "../ui-componets/Back";
import { useTranslation } from 'react-i18next';
import { useTokenAuth } from '../hooks/useTokenAuth';

interface IProps {
    getProfileData : any
    postProfileData: any
    personalDetails: any
    loginDetails: any
    accountDetails: any
    contactDetails:any
    apiEnd:any
    epAPI: any
    history: any
    tokenDetails:any
    global:any
    getBalance:any
    isProfileFetching: boolean
    isUserFetching: boolean
    credentialChangeLogout: any
    dieselCardUser?: boolean
    shopUser?: boolean
}

function Details(props: IProps) {
    const { t } = useTranslation();
    const [isLoader, setIsLoader] = useState(false);
    const { credentialChangeLogout } = props;
    const notify = (msg: any) => toast.success(msg, {
        position: "top-right",
        closeButton: false,
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        className: "taost-bg-green",
        icon: ({}) =>  <img src="/profile/static/toast-tick.svg"/>
    });

    const emailNotify = (msg: any) => toast.success(msg, {
        position: "top-right",
        closeButton: false,
        autoClose: 7000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        className: "taost-bg-green",
        icon: ({}) =>  <img src="/profile/static/toast-tick.svg"/>
    });

    const errNotify = (msg: any) => toast.error(msg, {
        position: "top-right",
        closeButton: false,
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        className: "taost-bg-red",
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // get sso object from localStorage
    let ssoData = props.global.SSO_USER;
    let isSsoUser = ssoData?.enabled;

    // Use reusable token authentication hook
    useTokenAuth('/profile/details', props.global, props.tokenDetails, props.history);

      useEffect(() => {
        window.scrollTo(0, 0);
        getProfileData();
      }, [props.tokenDetails]);

    const sections = [
        { key: 'Home', content: t('Your Account'), className: 'parent-breadcrumbs font-styleLight', href: '/account', link: true },
        { key: 'Details', className: 'child-breadcrumbs font-styleLight', content: t('Your Details'), link: false },
    ]
    const {getProfileData, personalDetails, accountDetails, loginDetails, apiEnd, isUserFetching, isProfileFetching , contactDetails,epAPI} = props;

    useEffect(() => {
        getProfileData();
    }, []);

    const handleFormSubmit = (data:any) => {
        let bodyFormData = new FormData();
        bodyFormData.append('personalDetails.firstName', data.firstName ? data.firstName : '');
        bodyFormData.append('personalDetails.lastName', data.lastName ? data.lastName : '');
        bodyFormData.append('personalDetails.title', data.title);
        bodyFormData.append('personalDetails.gender', data.gender);
        bodyFormData.append('personalDetails.dob', data.dob);
        axios({
            withCredentials: true,
            method: 'post',
            url: `${apiEnd}/rest/my-account/profile/save/personalDetails/V2`,
            data: bodyFormData,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                Authorization: props.tokenDetails.access_token //the token is a variable which holds the token
              }
        })
        .then(function (response:any) {
            setIsLoader(true);
            getProfileData();
            notify(t('Name Change Saved!'));
        })
        .catch(function (error:any) {
            // console.log(error);
        });
    }



    const handleEmailFormSubmit = (data:any) => {
        let bodyFormData = new URLSearchParams();
        bodyFormData.append('accountDetails.email', data.Email);
        axios({
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json, text/plain, */*',
                    Authorization: props.tokenDetails.access_token //the token is a variable which holds the token
            },
            withCredentials: true,
            method: 'POST',
            url: `${apiEnd}/rest/my-account/profile/save/email/V2`,
            data: bodyFormData
        })
        .then(function (response:any) {
            setIsLoader(true);
            emailNotify('Your email change will be complete when you have followed the steps in the email we have just sent to your new email address. You will be promptly logged out!');
            setTimeout(() => {
               credentialChangeLogout()
            }, 2000)
        })
        .catch(function (error) {
            if (error.response) {
                errNotify(error.response.data.message);
            }
        })
    }

    const handlePasswordSubmit = (data:any) => {
        let bodyFormData = new URLSearchParams();
        bodyFormData.append('accountDetails.existingPassword', data.password);
        bodyFormData.append('accountDetails.newPassword', data.newPassword);

        axios({
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Accept': 'application/json, text/plain, */*',
                Authorization: props.tokenDetails.access_token
            },
            withCredentials: true,
            method: 'POST',
            url: `${apiEnd}/rest/my-account/profile/save/password/V2`,
            data: bodyFormData
        })
        .then(function (response:any) {
            setIsLoader(true);
            notify('Password Change Saved. You will be promptly logged out!');
            setTimeout(() => {
                credentialChangeLogout()
            }, 2000)
        })
        .catch(function (error) {
            if (error.response) {
                errNotify(error.response.data.message);
            }
        })
    }

    const handlePhoneNumberSubmit = (data: any) => {
        axios.put(
        `${epAPI}/api/users/update/phoneNumber`,
        {
            mobileNumber: data?.phoneNumber,
            userKey: props?.loginDetails?.id
        },
        {
            headers: {
            'Content-Type': 'application/json', // explicitly set content type
            Authorization: `${props.tokenDetails.access_token}` // add Bearer prefix
            }
        }
        )
        .then(function (response:any) {
            notify('Phone number change saved.!');
            setTimeout(() => {
                setIsLoader(true);
                getProfileData();
            }, 2000)
        })
        .catch(function (error) {
            if (error.response) {
                errNotify(error.response.data.message);
            }
        });
        };


    return (
        <div>
            { ((isProfileFetching || isUserFetching) && !isLoader) || isProfileFetching === undefined ?
                <div>
                    <Loader/>
                </div>:
                <div className="AccountsProfile-layout">
                    <ToastContainer />
                    <div className="AccountsProfile-acc-page">
                        <div className="maximising-the-width">
                            {
                                props.shopUser && <div className="dropdown-for-activity dropdown-for-order pt-0 pl-5">
                                    <Back
                                        refreshToken={props.tokenDetails.refresh_token}
                                        dieselCardUser={props.dieselCardUser}/>
                                </div>
                            }
                            <div className="page-heads-title-for-all-accounts">
                                <div className="page-heads-title-for-all-accounts-img">
                                    <img src="/profile/static/your-deatils-main.svg" />
                                </div>
                                <div className="page-heads-title-for-all-accounts-content">
                                    <p className="m-0 font-styleBold">{t('Your Details')}</p>
                                </div>
                                {sections.length > 0 && !props.shopUser ? <BreadCrumbs
                                    sections={sections}
                                    handleClick={(url: string) => props.history.push(url)}
                                    backAction={() => props.history.goBack()} />
                                    : null}
                            </div>
                            {  personalDetails &&  <AccountsProfile firstName={personalDetails.firstName}
                                lastName={personalDetails.lastName}
                                email={accountDetails.email}
                                phoneNo = {contactDetails.phoneNo}
                                ssoUser={isSsoUser}
                                mfaStatus={loginDetails?.mfaStatus}
                                onFormSubmit = { (data) => handleFormSubmit(data)}
                                onConfirmEmailSave = {(data)=> handleEmailFormSubmit(data)}
                                onPasswordChangeSave = {(data) => handlePasswordSubmit(data)}
                                onConfirmPhoneNumberSave = {(data) => handlePhoneNumberSubmit(data)}

                            />
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}


const mapStateToProps = (state: any) => ({
    personalDetails : state.details.profileData.personalDetails,
    accountDetails : state.details.profileData.accountDetails,
    contactDetails:state.details.profileData.contactDetails,
    tokenDetails: state.join.tokens,
    loginDetails: state.join.loginDetails,
    apiEnd : state.global.REST_API,
    epAPI: state.global.EP_ADMIN_URL,
    global: state.global,
    isProfileFetching: state.details.isProfileFetching,
    isUserFetching: state.ui.isUserFetching,
});

export default connect(mapStateToProps, {getProfileData, postProfileData, credentialChangeLogout})(Details);